import Vue from 'vue'
import App from './App.vue'
import VueMask from 'v-mask'
import store from './store'
import myApi from './gavnoCode/ApiHandler'
import router from './router'



Vue.config.productionTip = false;
Vue.prototype.$myApi = myApi;
Vue.use(VueMask);


new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
